import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-complaint-seller',
  standalone: true,
  templateUrl: '../../assets/complaint-seller.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamComplaintSellerIcon {}
